import { createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';

export const initialState = {
  model: {
    filings: [],
    availableFilters: {},
    selectedFilters: {},
  },
  meta: {
    errorMessage: '',
    status: STATUS.LOADING,
    itemLoading: [],
  },
};

const filingList = createSlice({
  name: 'filingList',
  initialState,
  reducers: {
    reset: () => initialState,
    request: state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
      state.meta.itemLoading = [];
    },
    success: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.meta.count = action.payload.result.count;
      state.meta.next = action.payload.result.next;
      state.meta.previous = action.payload.result.previous;
      state.model.filings = action.payload.result.filings;
      state.model.availableFilters = action.payload.result.availableFilters;
      state.model.selectedFilters = action.payload.result.selectedFilters;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
    filtersRequest: (state, action) => {
      state.model.selectedFilters = {
        ...state.model.selectedFilters,
        ...action.payload,
      };
    },
    correctionRequest: (state, action) => {
      state.meta.itemLoading = [...state.meta.itemLoading, action.payload.id];
    },
    correctionSuccess: (state, action) => {
      state.meta.itemLoading = state.meta.itemLoading.filter(id => id !== action.payload.result.id);
    },
    correctionFailure: (state, action) => {
      state.meta.itemLoading = state.meta.itemLoading.filter(
        id => id !== action.payload.requestPayload.id
      );
    },
  },
});

export const {
  reset: filingListReset,
  request: filingListRequest,
  success: filingListSuccess,
  failure: filingListFailure,
  filtersRequest: filingListFiltersRequest,
  correctionRequest: filingListCorrectionRequest,
  correctionSuccess: filingListCorrectionSuccess,
  correctionFailure: filingListCorrectionFailure,
} = filingList.actions;

export default filingList.reducer;
